import * as types from './mutation-types'
// 定义对数据修改的逻辑
const mutations = {
  // 第二个参数为修改的对象，被赋予的值
  [types.SET_COURSEID] (state, courseId) {
    state.courseId = courseId
  },
  [types.SET_USERID] (state, userId) {
    state.userId = userId
  },
  [types.SET_STUDY_EXPERIENCE] (state, studyExperience) {
    state.studyExperience = studyExperience
  },
  [types.SET_WORK_EXPERIENCE] (state, workExperience) {
    state.workExperience = workExperience
  },
  [types.SET_USER] (state, user) {
    // state.user = Object.assign({}, user)
    state.user = user
  },
  [types.SET_RECOMMEND_COURSE] (state, recommendCourse) {
    state.recommendCourse = recommendCourse
  },
  [types.SET_CURRENTDATA] (state, currentData) {
    state.currentData = currentData
  },
  [types.SET_SEARCHMARK] (state, searchMark) {
    state.searchMark = searchMark
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js